export default __webpack_public_path__ + "static/media/beth.73013961.svg";